import React, { useEffect, useState } from "react";
import api from "../../services/api";
import InputMask from "react-input-mask";

const buildOptions = (rows, field) => {
    const uniqueValues = Array.from(
        new Set(
            rows
                .map((item) => item[field])
                .filter((value) => typeof value === "string" && value.trim() !== "")
                .map((value) => value.trim())
        )
    ).sort((left, right) => left.localeCompare(right, "pt-BR"));

    return uniqueValues.map((value) => ({ [field]: value }));
};

function Filtrossindicalizados({ filtros, onDataChange, iniciarRequisicao, qtd_reg_pagina }) {
    const [unidade, setUnidade] = useState(filtros.unidade);
    const [curso, setCurso] = useState(filtros.curso);
    const [situacao, setSituacao] = useState(filtros.situacao);
    const [aniversariantes, setAniversariantes] = useState(filtros.aniversariantes);
    const [inifiliacao, setInicioFiliacao] = useState(filtros.inifiliacao);
    const [fimfiliacao, setFimFiliacao] = useState(filtros.fimfiliacao);
    const [tipocontribuicao, setTipoContribuicao] = useState(filtros.tipocontribuicao);
    const [cpf, setCpf] = useState(filtros.cpf);
    const [departamento, setDepartamento] = useState(filtros.departamento);

    const [unidades, setUnidades] = useState([]);
    const [cursos, setCursos] = useState([]);
    const [departamentos, setDepartamentos] = useState([]);

    const handlePesquisarClick = () => {
        iniciarRequisicao(1, qtd_reg_pagina);
    };

    const handleCursoChange = (event) => {
        const newCurso = event.target.value;
        setCurso(newCurso);
        onDataChange({ curso: newCurso });
    };

    const handleDepartamentoChange = (event) => {
        const newDepartamento = event.target.value;
        setDepartamento(newDepartamento);
        onDataChange({ departamento: newDepartamento });
    };

    const handleCpfChange = (event) => {
        const newCpf = event.target.value.replace(/[^\d./-]/g, '');
        setCpf(newCpf);
        onDataChange({ cpf: newCpf });
    };

    const handleSituacaoChange = (event) => {
        const newSituacao = event.target.value;
        setSituacao(newSituacao);
        onDataChange({ situacao: newSituacao });
    };

    const handleUnidadeChange = (event) => {
        const newUnidade = event.target.value;
        setUnidade(newUnidade);
        onDataChange({ unidade: newUnidade });
    };

    const handleAniversariantesChange = (event) => {
        const newAniversariantes = event.target.value;
        setAniversariantes(newAniversariantes);
        onDataChange({ aniversariantes: newAniversariantes });
    };

    const handleTipoContribuicaoChange = (event) => {
        const newTipoContribuicao = event.target.value;
        setTipoContribuicao(newTipoContribuicao);
        onDataChange({ tipocontribuicao: newTipoContribuicao });
    };

    const handleInicioFiliacaoChange = (event) => {
        const newIniFiliacao = event.target.value;
        setInicioFiliacao(newIniFiliacao);
        onDataChange({ inifiliacao: newIniFiliacao });
    };

    const handleFimFiliacaoChange = (event) => {
        const newFimFiliacao = event.target.value;
        setFimFiliacao(newFimFiliacao);
        onDataChange({ fimfiliacao: newFimFiliacao });
    };

    useEffect(() => {
        setUnidade(filtros.unidade || "");
        setCurso(filtros.curso || "");
        setSituacao(filtros.situacao || "");
        setAniversariantes(filtros.aniversariantes || "");
        setInicioFiliacao(filtros.inifiliacao || "");
        setFimFiliacao(filtros.fimfiliacao || "");
        setTipoContribuicao(filtros.tipocontribuicao || "");
        setCpf(filtros.cpf || "");
        setDepartamento(filtros.departamento || "");
    }, [filtros]);

    useEffect(() => {
        async function carregarFiltros() {
            try {
                const response = await api.get("/t_socio", {
                    params: {
                        user: localStorage.getItem("user"),
                        gmt: '-04:00',
                    }
                });

                const rows = response.data?.rows || [];
                setUnidades(buildOptions(rows, "UNIDADE"));
                setCursos(buildOptions(rows, "DEPARTAMENTO"));
                setDepartamentos(buildOptions(rows, "DEPARTAMENTO"));
            } catch (error) {
                console.error("Erro ao carregar filtros de associados:", error);
                setUnidades([]);
                setCursos([]);
                setDepartamentos([]);
            }
        }

        carregarFiltros();
    }, []);

    const formatCNPJ = (cnpj) => {
        if (!cnpj) {
            return cnpj;
        }

        if (cnpj.length <= 11) {
            return cnpj.replace(/\D/g, '').replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
        }

        return cnpj.replace(/\D/g, '').replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
    };

    return (
        <>
            <div className="row">
                <div className="col-xl-2 col-md-12 col-sm-12">
                    <label>Unidade</label>
                    <select
                        name="unidade"
                        className="form-control"
                        value={unidade}
                        onChange={handleUnidadeChange}
                    >
                        <option value=""></option>
                        {unidades.map((item) => (
                            item.UNIDADE && (
                                <option key={item.UNIDADE} value={item.UNIDADE}>
                                    {item.UNIDADE}
                                </option>
                            )
                        ))}
                    </select>
                </div>

                <div className="col-xl-3 col-md-4 col-sm-12">
                    <label>Curso</label>
                    <select
                        name="curso"
                        className="form-control"
                        value={curso}
                        onChange={handleCursoChange}
                    >
                        <option value=""></option>
                        {cursos.map((item) => (
                            item.DEPARTAMENTO && (
                                <option key={item.DEPARTAMENTO} value={item.DEPARTAMENTO}>
                                    {item.DEPARTAMENTO}
                                </option>
                            )
                        ))}
                    </select>
                </div>

                <div className="col-xl-3 col-md-4 col-sm-12">
                    <label>Departamento</label>
                    <select
                        name="departamento"
                        className="form-control"
                        value={departamento}
                        onChange={handleDepartamentoChange}
                    >
                        <option value=""></option>
                        {departamentos.map((item) => (
                            item.DEPARTAMENTO && (
                                <option key={item.DEPARTAMENTO} value={item.DEPARTAMENTO}>
                                    {item.DEPARTAMENTO}
                                </option>
                            )
                        ))}
                    </select>
                </div>

                <div className="col-2">
                    <small className="text-secondary">CPF</small>
                    <input
                        type="text"
                        name="cpf"
                        className="form-control"
                        onChange={handleCpfChange}
                        value={formatCNPJ(cpf)}
                    />
                </div>

                <div className="col-xl-2 col-md-12 col-sm-12">
                    <label>Situacao</label>
                    <select
                        name="situacao"
                        className="form-control"
                        value={situacao}
                        onChange={handleSituacaoChange}
                    >
                        <option value=""></option>
                        <option value="Ativo">Ativo</option>
                        <option value="Aposentado">Aposentado</option>
                    </select>
                </div>
            </div>

            <div className="row mt-2">
                <div className="col-xl-2 col-md-12 col-sm-12 mt-2">
                    <label>Aniversarios</label>
                    <select
                        name="aniversariantes"
                        className="form-control"
                        value={aniversariantes}
                        onChange={handleAniversariantesChange}
                    >
                        <option value=""></option>
                        <option value="dodia">Do dia</option>
                        <option value="dasemana">Da semana</option>
                        <option value="domes">Do mes</option>
                    </select>
                </div>

                <div className="col-xl-2 col-md-12 col-sm-12 mt-2">
                    <small className="text-secondary">Filiacao entre</small>
                    <InputMask
                        mask="99/99/9999"
                        maskPlaceholder="dd/mm/yyyy"
                        name="inifiliacao"
                        className="form-control"
                        value={inifiliacao}
                        onChange={handleInicioFiliacaoChange}
                    />
                </div>

                <div className="col-xl-2 col-md-12 col-sm-12 mt-2">
                    <small className="text-secondary">e</small>
                    <InputMask
                        mask="99/99/9999"
                        maskPlaceholder="dd/mm/yyyy"
                        name="fimfiliacao"
                        className="form-control"
                        value={fimfiliacao}
                        onChange={handleFimFiliacaoChange}
                    />
                </div>

                <div className="col-xl-4 col-md-12 col-sm-12 mt-2">
                    <small className="text-secondary">Contribuicao por</small>
                    <div className="form-control mb-0">
                        <select
                            name="tipocontribuicao"
                            value={tipocontribuicao}
                            onChange={handleTipoContribuicaoChange}
                        >
                            <option value=""></option>
                            <option>Desconto em folha</option>
                            <option>Boleto bancario</option>
                            <option>Debito em conta</option>
                            <option>PIX</option>
                        </select>
                    </div>
                </div>

                <div className="col-xl-2 col-md-12 col-sm-12 mt-2 text-end">
                    <br />
                    <button className="btn btn-success" onClick={handlePesquisarClick}>
                        <i className="bi bi-search me-2"></i>Pesquisar
                    </button>
                </div>
            </div>
        </>
    );
}

export default Filtrossindicalizados;
